<template>
  <div>
    <b-navbar-nav class="nav">
      <b-nav-item id="email" v-b-toggle.sidebar-Notification>
        <!-- to="/email" -->
        <feather-icon
          icon="MailIcon"
          size="21"
          :badge="count"
          badge-classes="bg-danger"
        />
        <b-tooltip
          triggers="hover"
          target="email"
          title="پیام ها"
          :delay="{ show: 500, hide: 50 }"
        />
      </b-nav-item>
    </b-navbar-nav>

    <b-sidebar id="sidebar-Notification" width="400px" right backdrop>
      <template #header="{ hide }">
        <div
          class="dropdown-header d-flex p-1 align-items-center justify-content-between"
        >
          <!-- <feather-icon
            class="mr-50"
            icon="BellIcon"
            size="22"
            style="color: #fbad25"
          /> -->
          <div>
            <h4 class="notification-title mb-0 mr-1 ml-auto">پیام ها</h4>
          </div>
          <!-- <span>
            <b-badge
              pill
              variant="light-primary" 
            >
              {{ count.count_unread_notifications }} New
            </b-badge>
          </span> -->

          <div @click="hide" class="close">
            <feather-icon icon="XIcon" size="22" />
          </div>
        </div>
      </template>

      <div class="px-1">
        <div v-if="loading">
          <b-skeleton
            v-for="i in 10"
            :key="i"
            height="40px"
            width="350px"
            class="my-1"
          />
        </div>
        <div v-else-if="notifications.length">
          <vue-perfect-scrollbar
            :settings="perfectScrollbarSettings"
            class="scrollable-container media-list scroll-area"
            style="max-height: 81vh"
            tagname="div"
            ref="scroll"
            @ps-scroll-y="onScroll"
          >
            <div
              v-for="(notification, index) in notifications"
              :key="index"
              v-b-tooltip.hover.top="calcDate(notification.data.created_at)"
              @click="showEmailDetails(notification.data)"
            >
              <b-media
                :class="[
                  notification.allSend !== notification.seenCound &&
                  notification.can_read
                    ? 'bg-unread '
                    : 'border',
                ]"
                class="align-items-center p-1 round my-50"
              >
                <template #aside>
                  <b-avatar
                    size="45"
                    rounded
                    :src="notification.data.notifiable.avatar"
                  >
                  </b-avatar>
                </template>

                <div class="d-flex align-items-center justify-content-between">
                  <div class="w-100">
                    <p
                      class="media-heading mb-0 d-flex align-items-center justify-content-between"
                    >
                      <span class="font-weight-normal"
                        >{{ notification.data.data.sender_name }}
                      </span>
                    </p>
                    <p class="notification-text mb-0">
                      {{ notification.data.data.subject }}
                    </p>
                    <hr v-if="notification.allSend > 1" />
                    <div class="d-flex align-items-center">
                      <b-button
                        v-if="
                          notification.allSend !== notification.seenCound &&
                          notification.can_read
                        "
                        variant="primary"
                        size="sm"
                        @click="showEmailDetails(notification.data)"
                        class="mr-50"
                      >
                        مشاهده
                      </b-button>

                      <small class="mr-50" v-if="notification.allSend > 1">
                        ارسال شده :

                        <b-badge class="pt-50" variant="primary">
                          {{ notification.allSend }}
                        </b-badge>
                      </small>
                      <!-- <br/> -->
                      <small v-if="notification.allSend > 1">
                        خوانده شده :

                        <b-badge class="pt-50" variant="primary">
                          {{ notification.seenCound }}
                        </b-badge>
                      </small>
                    </div>
                  </div>
                </div>
              </b-media>
            </div>
          </vue-perfect-scrollbar>
          <span class="ml-1">
            <b-button
              class="p-1"
              variant="primary"
              block
              @click="$router.push({ name: 'apps-email' })"
              >مشاهده همه پیام ها
            </b-button>
          </span>
        </div>
      </div>
    </b-sidebar>
  </div>
</template>

<script>
import {
  BSidebar,
  BImg,
  BButton,
  VBToggle,
  BLink,
  BSkeleton,
  BMedia,
  BAvatar,
  BBadge,
  BTooltip,
  VBTooltip,
  BNavbarNav,
  BNavItem,
} from "bootstrap-vue";

import VuePerfectScrollbar from "vue-perfect-scrollbar";
import Ripple from "vue-ripple-directive";

export default {
  components: {
    BSidebar,
    BTooltip,
    BMedia,
    BAvatar,
    BBadge,
    BImg,
    BButton,
    BLink,
    BSkeleton,
    BNavbarNav,
    BNavItem,
    VBTooltip,

    VuePerfectScrollbar,
  },
  directives: {
    "b-toggle": VBToggle,
    "b-tooltip": VBTooltip,

    Ripple,
  },
  data() {
    return {
      notifications: [],
      loading: false,
      perfectScrollbarSettings: {
        maxScrollbarLength: 60,
        wheelPropagation: false,
      },
      interval: "",
      pagination: {},
      visible: false,
    };
  },
  computed: {
    count() {
      return this.$store.state.appConfig.count;
    },
  },
  created() {
    this.loading = true;
    this.getNotifications();
    this.loading = false;
  },
  methods: {
    showEmailDetails(email) {
      this.$store.dispatch("appConfig/getEmailViewData", email);
      this.$router
        .push({
          name: "apps-email",
        })
        .catch((err) => {});
    },
    onScroll(e) {
      let rail = document.querySelector(".ps__rail-y");
      let scroll = this.$refs.scroll.$el;

      if (
        scroll.scrollHeight.toFixed(0) - rail.scrollHeight.toFixed(0) ==
          scroll.scrollTop.toFixed(0) &&
        this.pagination.total_pages > this.pagination.current_page
      ) {
        this.getNotifications(this.pagination.current_page + 1);
      }
    },

    async getNotifications(page) {
      // this.loading = true;
      try {
        const params = {
          per_page: 10,
          page: page || 1,
        };
        const { data } = await this.$http.get("/panel/notifications", {
          params,
        });
        if (page) {
          this.notifications.push(
            ...data.data.notifications.map((item) => {
              return {
                data: item[0],
                seenCound: item.filter((item) => item.read_at).length,
                allSend: item.length,
              };
            })
          );
        } else {
          this.notifications = data.data.notifications.map((item) => {
            return {
              data: item[0],
              seenCound: item.filter((item) => item.read_at).length,
              allSend: item.length,
            };
          });
        }
        this.pagination = data.data.meta.pagination;
      } catch (error) {}
      // this.loading = false
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@core/scss/base/bootstrap-extended/include";
@import "~@core/scss/base/core/colors/palette-variables.scss";

.b-sidebar {
  background-color: black !important;
}
.btn-secondary:hover {
  box-shadow: none !important;
}
.media:hover {
  box-shadow: 0px 0 5px #80808024;
}
.b-sidebar.b-sidebar-right > .b-sidebar-header .close {
  cursor: pointer;
  border: 1px solid transparent;
  border-radius: 3px;
}
.b-sidebar.b-sidebar-right > .b-sidebar-header .close:hover {
  border: 1px solid gray;
}
</style>
